<a (click)="toggleSelected()">
    <img src="assets/icons/favorite-true.svg" *ngIf="selected" alt="Favorite icon">
    <img src="assets/icons/favorite-false.svg" *ngIf="!selected" alt="Favorite border icon">
</a>